var site = site || {};

site.client = site.client || {};

(function ($) {
  Drupal.behaviors.contentBlockFormatterV1 = {
    isMobile: false,
    unisonDependent: true,
    unisonReady: false,
    nodes: {},
    selector: {
      container: '.js-content-block--grid',
      item: '.js-content-block--grid-item',
      innerItems: '.js-content-block--grid-inner-item'
    },

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }

      // if Unison is not ready on attach, it triggers change on initialization
      if (!!Unison.fetch.now()) {
        self.unisonReady = true;
      }

      Unison.on('change', function () {
        if (!self.attached && self.unisonDependent) {
          // re attach on unisonReady, the initial attach was return
          self.attach(context);
        }
      });

      if (!self.unisonReady && self.unisonDependent) {
        return;
      }

      $(self.selector.container).each(function () {
        var $this = $(this);
        if (!!$this.data('isSlider')) {
          self.getDom($this);
          self.setSettings($this);
          self.setEvents($this);
          self.setItemsLayout($this);
          setTimeout(function () {
            // allow items layout to finish
            self.initSlider($this);
          }, 100);
        }
      });
      // Reinit the settings
      self.resetSliderForExtole();
      self.attached = true;
    },

    getDom: function ($that) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$items = $(self.selector.innerItems, $that);
      if ($that.nodes.$items.length < 1) {
        $that.nodes.$items = $(self.selector.item, $that);
      }
    },

    initSlider: function ($that) {
      var self = this;
      var hasPeeking =
        !!$that.settings.sliderConfig && !!$that.settings.sliderConfig.peekingPercent;
      var sliderSettings = {
        slidesToShow: $that.settings.breakpoints.extra_large || 3,
        slidesToScroll: 1,
        infinite: $that.settings.sliderConfig.infinite,
        dots: false,
        arrows: $that.settings.sliderConfig.arrows,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: $that.settings.breakpoints.mobile || 1,
              arrows: false,
              dots: $that.settings.sliderConfig.dots,
              infinite: $that.settings.sliderConfig.infinite
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: $that.settings.breakpoints.desktop || 3,
              infinite: $that.settings.sliderConfig.infinite
            }
          }
        ],
        onInit: function (slick) {
          // Get copy of original swipeEnd function
          var ogSwipeEnd = slick.swipeEnd;

          self.togglePeekingClasses($that);
          $that.trigger('slider-initialised');

          // Override function
          slick.swipeEnd = function (e) {
            // Call og function
            ogSwipeEnd.call(slick, e);
            // Remove click.slick event once swipe is done
            $(e.target).off('click.slick');
          };
        },
        onAfterChange: function () {
          $that.trigger('slider-changed--after');
        }
      };
      $that.slick(sliderSettings);
    },

    setSettings: function ($that) {
      var self = this;

      $that.settings = {};
      $that.settings.direction = $('html').attr('dir') || 'ltr';
      $that.settings.breakpoints = $that.data('breakpoints') || {};
      $that.settings.sliderConfig = $that.data('sliderConfig') || {};
      $that.settings.customSliderConfig = $that.data('customSliderConfig') || {};

      $that.settings.sliderConfig.dots = $that.settings.sliderConfig.dots > 0 ? true : false;
      $that.settings.sliderConfig.arrows = $that.settings.sliderConfig.arrows > 0 ? true : false;
      $that.settings.sliderConfig.infinite =
        $that.settings.sliderConfig.infinite > 0 ? true : false;

      if (!!$that.settings.sliderConfig && !!$that.settings.sliderConfig.peeking) {
        self.setPeaking($that);
      }
    },

    setPeaking: function ($that) {
      var peeking = '';
      $that.settings.sliderConfig.peekingPercent = {};
      Object.keys($that.settings.breakpoints).forEach(function (key) {
        $that.settings.breakpoints[key] = parseInt($that.settings.breakpoints[key]);
        peeking =
          typeof $that.settings.sliderConfig.peeking[key] === 'string'
            ? $that.settings.sliderConfig.peeking[key]
            : '';
        if (peeking.indexOf('.') === 0) {
          $that.settings.sliderConfig.peekingPercent[key] =
            ((100 / $that.settings.breakpoints[key]) * parseInt(peeking.replace('.', ''))) / 100;
        }
      });
    },

    setEvents: function ($that) {
      var self = this;
      var currentBreakpoint = self.getBreakpoint();
      var afterChangeBreakpoint = '';
      if ($that.settings.customSliderConfig['items_per_slide']) {
        Unison.on('change', function () {
          afterChangeBreakpoint = self.getBreakpoint();
          if (currentBreakpoint !== afterChangeBreakpoint) {
            currentBreakpoint = afterChangeBreakpoint;
            self.swapLayout($that);
          }
        });
      }
    },

    swapLayout: function ($that) {
      var self = this;
      self.setItemsLayout($that);
    },

    setItemsLayout: function ($that) {
      var self = this;
      var breakpoint = self.getBreakpoint();
      var itemsPerSlide = $that.settings.customSliderConfig['items_per_slide'][breakpoint];
      if (itemsPerSlide === 1 || itemsPerSlide === $that.attr('data-items-per-slide')) {
        return;
      }
      $that.attr('data-items-per-slide', itemsPerSlide);
      $that.nodes.$items.detach();
      $that.empty();
      var $tmp = $('<div>').addClass('slide-wrapper js-slide-wrapper');
      var slideIndex = 0;
      var $slide = $tmp.clone(true).data('slideIndex', slideIndex);
      var reinitSlider = false;
      if ($that.hasClass('slick-initialized')) {
        $that.slick().destroy;
        $that.removeClass('slick-initialized slick-slider');
        reinitSlider = true;
      }
      $that.nodes.$items.each(function (i) {
        var $this = $(this);
        $slide.appendTo($that);
        $this.appendTo($slide);

        if ((i + 1) % itemsPerSlide === 0) {
          // we need to make a new slide wrapper
          slideIndex++;
          $slide = $tmp.clone(true).data('slideIndex', slideIndex);
        }
      });
      if (reinitSlider) {
        setTimeout(function () {
          self.initSlider($that);
        }, 100);
      }
    },

    getBreakpoint: function () {
      var width = parseInt(Unison.fetch.now().width, 10);
      if (width <= parseInt(Unison.fetch.all()['usn-medium'], 10)) {
        return 'mobile';
      }
      if (width <= parseInt(Unison.fetch.all()['usn-xxx-large'], 10)) {
        return 'desktop';
      }
      if (width <= parseInt(Unison.fetch.all()['usn-xwide'], 10) > 0) {
        return 'large';
      }
      return 'extra_large';
    },

    togglePeekingClasses: function ($that) {
      var self = this;
      if ($that.settings.sliderConfig.length < 1 || !$that.settings.sliderConfig.peekingPercent) {
        return;
      }
      var direction = $that.settings.direction === 'ltr' ? 'right' : 'left';
      var breakpoint = self.getBreakpoint();
      var hasSlides = $that.settings.breakpoints[breakpoint] < $that.nodes.$items.length;
      var percent = $that.settings.sliderConfig.peekingPercent[breakpoint] || 0;
      if (percent > 0 && hasSlides) {
        percent = self.closestNumber(percent, 5) || 5;
        $that.find('.slick-list').addClass('padding-' + direction + '-' + percent);
        setTimeout(function () {
          $that.trigger('slider-peeking-changed');
        }, 200);
      }
    },

    // Find closest number to n divisible by m
    closestNumber: function (n, m) {
      let q = parseInt(n / m);
      let n1 = m * q;
      let n2 = n * m > 0 ? m * (q + 1) : m * (q - 1);
      if (Math.abs(n - n1) < Math.abs(n - n2)) {
        return n1;
      } else {
        return n2;
      }
    },

    resetSliderForExtole: function () {
      var self = this;
      const extoleZoneFooter = $('#extole_zone_global_footer');

      extoleZoneFooter.on('extoleConsent', function (e, $this) {
        // Reinitialize Layout and Settings
        self.getDom($this);
        self.setSettings($this);
        self.setEvents($this);
        self.setItemsLayout($this);
      });
    },

    attached: false
  };
})(jQuery);
